export const REPORTS_NAMESPACE_TRANSLATIONS = {
  generateReport: {
    title: "Generowanie Raportów",
    description:
      "Generuj raporty o zwierzętach farmowych z informacjami związanymi z rasą, gatunkiem, płcią i ich istotnymi danymi.",
    note: "Raporty będą dostępne w sekcji Raporty po wygenerowaniu, może to potrwać do 15 sekund.",
    pending: "Generowanie raportu...",
    success: "Raport wygenerowany pomyślnie!",
    error: "Błąd podczas generowania raportu. Spróbuj ponownie.",
    button: "Generuj Raport Zwierząt",
    buttonGenerating: "Generowanie...",
  },

  individualAnimalReports: {
    title: "Indywidualne Raporty Zwierząt",
    description:
      "Generuj szczegółowe raporty o zwierzęciu, rozrodzie, zdrowiu i produktywności.",
    note: "Raporty będą dostępne poniżej po wygenerowaniu, może to potrwać do 15 sekund.",
    button: "Generuj raport zwierzęcia",
  },

  filters: {
    all: "Wszystkie Raporty",
    animal: "Raporty Zwierząt",
    financial: "Raporty Finansowe",
    production: "Raporty Produkcji",
  },

  status: {
    pending: "Oczekujące",
    processing: "Przetwarzanie",
    completed: "Zakończone",
    failed: "Nieudane",
  },
}
